export const roundToTwoDecimals = (value) => Math.round(value * 100) / 100;
